import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button } from 'antd';
import {
  DashboardOutlined,
  PictureOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  ToolOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import adminApiService from '../../services/adminApi';

const { Header, Sider, Content } = Layout;

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState('dashboard');

  useEffect(() => {
    // 检查登录状态
    const checkAuth = async () => {
      if (!adminApiService.isAuthenticated()) {
        navigate('/admin/login');
        return;
      }

      try {
        await adminApiService.verify();
      } catch (error) {
        navigate('/admin/login');
      }
    };

    checkAuth();
  }, [navigate]);

  useEffect(() => {
    // 根据路由设置选中的菜单项
    const path = location.pathname;
    if (path.includes('/banners')) {
      setSelectedKey('banners');
    } else if (path.includes('/products')) {
      setSelectedKey('products');
    } else if (path.includes('/articles')) {
      setSelectedKey('articles');
    } else if (path.includes('/materials')) {
      setSelectedKey('materials');
    } else {
      setSelectedKey('dashboard');
    }
  }, [location]);

  const handleMenuClick = (key: string) => {
    setSelectedKey(key);
    navigate(`/admin/${key}`);
  };

  const handleLogout = () => {
    adminApiService.logout();
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: '仪表板',
    },
    {
      key: 'banners',
      icon: <PictureOutlined />,
      label: 'Banner 管理',
    },
    {
      key: 'products',
      icon: <AppstoreOutlined />,
      label: '产品管理',
    },
    {
      key: 'articles',
      icon: <FileTextOutlined />,
      label: '文章管理',
    },
    {
      key: 'materials',
      icon: <ToolOutlined />,
      label: '材料管理',
    },
  ];

  return (
    <Layout className="admin-layout">
      <Header className="admin-header">
        <h1>信力凯后台管理系统</h1>
        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          style={{ color: 'white' }}
        >
          退出登录
        </Button>
      </Header>
      <Layout>
        <Sider className="admin-sider" width={200}>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            style={{ height: '100%', borderRight: 0 }}
            theme="dark"
            items={menuItems}
            onClick={({ key }) => handleMenuClick(key)}
          />
        </Sider>
        <Layout style={{ padding: '0 24px 24px' }}>
          <Content className="admin-content">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
